import { Component, ViewChild } from '@angular/core';

import {
  AnsweredRfpPreviewComponent
} from '../../answered-rfp-preview/answered-rfp-preview/answered-rfp-preview.component';

@Component({
  selector: 'app-answered-rfp-preview-modal',
  templateUrl: './answered-rfp-preview-modal.component.html',
  styleUrls: ['./answered-rfp-preview-modal.component.scss']
})
export class AnsweredRfpPreviewModalComponent {
  @ViewChild(AnsweredRfpPreviewComponent) answeredRfpPreviewComponent!: AnsweredRfpPreviewComponent;
}
